import './main-loader.scss';

import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

import { isInWebView } from '@/shared/webview/env';

interface IProps {
  fullWidth?: boolean;
  fullScreen?: boolean;
}

const MainLoader: React.FC<IProps> = ({ fullWidth, fullScreen }) => {
  const webview = isInWebView();

  const rootClasses = [
    'main-loader',
    fullWidth ? 'main-loader--full-width' : '',
    fullScreen ? 'main-loader--fullscreen' : ''
  ].join(' ');

  return (
    <div className={rootClasses}>
      {webview ? (
        <Spin
          className="main-loader__spinner"
          indicator={<LoadingOutlined />}
          size="large"
        />
      ) : (
        <div className="main-loader__text">
          <span>Leasing</span>
        </div>
      )}
    </div>
  );
};

export default MainLoader;
